/* eslint-disable @typescript-eslint/unbound-method */
import { Instrument as InstrumentBase } from '../../bases/instrument';
import * as CONSTANTS from './constants';
import { globalScope } from '../../window/browser';
import { Aggregator } from './aggregator';
import { getConfigurationValue } from '../../state/init';

export class Instrument extends InstrumentBase {
  static featureName = CONSTANTS.FEATURE_NAME;

  constructor() {
    const aggregator = new Aggregator();
    const config = getConfigurationValue(
      `instruments.features.${Instrument.featureName}.mapped_attributes`,
    );

    super(aggregator, Instrument.featureName);
    this.config = config;
    this.start = this.start.bind(this);

    /* istanbul ignore else */
    if (this.loadFunctions) {
      this.loadPublicFunctions();
    }

    /* istanbul ignore else */
    if (this.auto) {
      this.start();
    }
  }

  loadPublicFunctions() {
    /* istanbul ignore else */
    if (globalScope.WMANS) {
      globalScope.WMANS.failed_load_resources = {};
      globalScope.WMANS.failed_load_resources.start = this.start;
    }
  }

  start() {
    const supportedErrorTypes = this.config?.metricSupport || [];

    /* istanbul ignore else */
    if (!globalScope?.addEventListener) {
      return;
    }

    /* istanbul ignore next */
    globalScope.addEventListener(
      'error',
      (e) => {
        let errorInfo;

        if (!e || !e.target.tagName) {
          errorInfo = {
            filename: e.filename || 'inline',
            initiator: 'browser',
            count: 1,
            message: e.message || 'Load error',
            stack: e.error ? e.error.stack : 'No stack trace available',
            status: 'error',
          };
          this.sendBrowserLog(errorInfo);
        } else if (
          supportedErrorTypes.includes(e.target.tagName.toLowerCase())
        ) {
          const fileName = e.target.src || e.filename || 'unknown';

          errorInfo = {
            name: fileName,
            attributes: {
              filename: fileName,
              initiator: e.target.tagName.toLowerCase(),
              count: 1,
              message: 'Load error',
              stack: 'No stack trace available',
              status: 'error',
            },
            startTime: performance.now(),
          };
          this.aggregator.incrementToContext(errorInfo);
        }
      },
      !0,
    );
  }

  sendBrowserLog(errorInfo) {
    /* istanbul ignore else */
    if (globalScope.WMANS?.logs?.fatal) {
      globalScope.WMANS.logs.fatal(
        `${this.featureName}.BrowserError`,
        {
          type: 'error-js',
          ...errorInfo,
        },
        true,
      );
    }
  }
}
